module.exports = __webpack_public_path__ + "img/building.07f2cd9d.jpg";